import React from 'react';
import { DragIcon } from '@components-library/Icons/iconsComponents';
import { useSortable } from '@dnd-kit/sortable';
import { CSS as DndKitCSS } from '@dnd-kit/utilities';
import cn from 'classnames';
import styles from './gridVisibilityDropdown.module.scss';

export const SortableItem = (props: {
  id: string | number;
  isDisabled: boolean;
  children: React.ReactNode;
  classNameDragIcon?: string;
  className?: string;
  onDragIconClick?: () => void;
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.id,
    disabled: props.isDisabled,
  });

  const style = {
    transform: DndKitCSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={cn(props.className, styles.item, { [styles.isDragging]: isDragging })}>
      {props.children}
      <DragIcon
        className={cn(props.classNameDragIcon, styles.dragIcon, { [styles.disabled]: props.isDisabled })}
        onClick={props.onDragIconClick}
      />
    </div>
  );
};
